const common = {
  between: "Entre",
  and: "et",
  all: "Tous",
  action: "Action",
  active: "Actif",
  add: "Ajouter",
  address: "Adresse",
  agencies: "Etablissements",
  agency: "Etablissement",
  attachment: "Attachement",
  attachments: "Attachements",
  amount: "Montant",
  bpu: "BPU",
  bpuTemplates: "BPU Templates",
  businessUnit: "UO",
  cancel: "Annuler",
  category: "Catégorie",
  close: "Fermer",
  code: "Code",
  city: "Commune",
  comment: "Commentaire",
  commentUpdated: "Commentaire mis à jour",
  commentUpdateFailed: "La mise à jour du commentaire a échoué",
  comments: "Commentaires",
  company: "Société",
  connection: "Connexion",
  contactInformation: "Coordonnées",
  contractor: "Sous-traitant",
  contractorAgreement: "Marché Sous-Traitant",
  create: "Créer",
  createDelegation: "Créer une délégation",
  creation: "Création",
  creator: "Créateur",
  currency: "Devise",
  currentCurrency: "EUR",
  date: "Date",
  dashboard: "Dashboard",
  deletion: "Suppression",
  deposits: "Cautions",
  depositType: "Dépôt",
  description: "Description",
  designation: "Désignation",
  disconnect: "Déconnexion",
  accountManage: "Gérer le compte",
  dgd: "Projet de Décompte",
  dsp: "DSP",
  director: "Dirigeant",
  display: "Affichage",
  documents: "Documents",
  download: "Télécharger",
  download_csv: "Télécharger en CSV",
  edifice: "Référence interne contrat",
  edition: "Édition",
  elements: "Éléments",
  email: "E-Mail",
  endDate: "Date de fin",
  envelopes: "Enveloppes",
  eotp: "eOTP",
  eur: "EUR",
  exporter: "Exporter",
  generate: "Générer",
  help: "Aide",
  id: "Id",
  import: "Importer",
  imputation: "Imputation",
  imputations: "Imputations",
  includingDepositUsed: "Dont caution",
  information: "Informations",
  invoiceLocation: "Lieu de facturation",
  deliveryLocation: "Lieu de livraison",
  supplyChainOrganization: "Organisation logistique",
  legalEntity: "Entité légale",
  mail: "Mail",
  manager: "Responsable",
  market: "Marché Sous-traitant",
  menu: "Menu",
  milestone: "Jalon",
  name: "Nom",
  next: "Suivant",
  node: "Noeud",
  nro: "NRO",
  number: "Numéro",
  object: "Objet",
  objects: "Objets",
  observation: "Observation",
  on: "sur",
  onDate: "le",
  options: "Options",
  oracleCode: "Code Oracle",
  oracle_projects: "Projets Oracle",
  oracleStatus: "Statut Oracle",
  oracleProject: "Projet Oracle",
  oracleTask: "Tâche Oracle",
  order: "Commande",
  orders: "Commandes",
  organization: "Organisation",
  owningOrganizationName: "Organisation propriétaire",
  payment: "Paiement",
  permissions: "Permissions",
  phone: "Téléphone",
  pm: "PM",
  prestations: "Prestations",
  prestationType: "Type de prestation",
  previous: "Précédent",
  profile: "Profil",
  project: "Projet",
  projects: "Projets",
  projectNumber: "Numéro de projet",
  quality: "Qualité",
  quantity: "Quantité",
  quantitatives: "Quantitatifs",
  rad: "RAD",
  reference: "Référence",
  refresh: "Rafraîchir",
  responsible: "Responsable",
  retention: "Retenue de garantie",
  retentions: "Retenues de garantie",
  rg: "RG",
  role: "Rôle",
  sap: "SAP",
  save: "Sauvegarder",
  selection: "Sélection",
  send: "Envoyer",
  service: "Service",
  siren: "SIREN",
  siret: "SIRET",
  startDate: "Date de début",
  status: "Statut",
  synchronize: "Synchroniser",
  synchronized: "Synchronisé",
  subcategory: "Sous-catégorie",
  taskNumber: "Numéro de tâche",
  template: "Template",
  to: "à",
  total: "Total",
  transitions: "Transitions",
  type: "Type",
  unit: "Unité",
  upload: "Téléverser",
  users: "Utilisateurs",
  value: "Valeur",
  vat: "TVA",
  validate: "Valider",
  validator: "Validateur",
  visibility: "Visibilité",
  workflow: "Workflow",
  contracts: "Contrats",
  popups: "Popups",
  preview: "Aperçu",
  delete: "Supprimer",
  evaluation: "Évaluation",
  noRecords: "Pas d'enregistrements",
  phoneCountryCode: "Indicatif Téléphonique",
  validations: "Validations",
};

const expressions = {
  accessNotGranted:
    "Vous n'avez pas les droits necessaires pour accéder à cette page.",
  addDocument: "Ajout d'un document",
  addedOn: "Ajoutée le",
  contractName: "Nom du contrat",
  createdAt: "Créé le",
  creationDate: "Date de création",
  delete: "Êtes-vous sûr de vouloir supprimer cet élément ?",
  deleteDocument: "Êtes-vous sûr de vouloir supprimer ce document ?",
  deleteContract:
    "Voulez-vous vraiment supprimer ce contrat et ses enveloppes, documents, validateurs et historiques de flux de travail associés ?",
  deleteEnvelope:
    "Voulez-vous vraiment supprimer cette enveloppe et ses documents, validateurs et historiques de flux de travail associés ?",
  disableAllEvaluations:
    "Voulez-vous vraiment désactiver l'évaluation sur tous les marchés sous-traitants ?",
  enableAllEvaluations:
    "Voulez-vous vraiment activer l'évaluation sur tous les marchés sous-traitants ?",
  endDate: "Date de fin",
  fetchingError: "La récupération des données n'a pas fonctionné",
  fileName: "Nom de fichier",
  keepProfile: `Vous êtes connecté sur un autre onglet en tant que {0}, souhaitez vous continuer avec ce profil ?`,
  leaveWithoutSaving:
    "Êtes-vous sûr de vouloir quitter la page sans enregistrer ?",
  mustBeAfter: "La date doit être supérieure à celle de la situation mensuelle",
  myTasks: "Mes actions ",
  myScope: "Mon périmètre",
  noAccessToEntity: "Vous n'avez pas les droits d'accès à cette entité.",
  noReadAccessToEntity:
    "Vous n'avez pas les droits en lecture pour accéder à cette entité.",
  noAttachment: "Aucun attachement",
  noData: "Aucune donnée à afficher",
  noDocumentSelected: "Aucun document sélectionné",
  noFileSelected: "Vous n'avez sélectionné aucun fichier",
  noDocumentTypleSelected: "Vous n'avez sélectionné aucun type de document",
  noPrestation: "Aucune prestation",
  noUser: "Aucun utilisateur",
  problemDescription: "Description du problème",
  projectName: "Nom du projet",
  projectConcerned: "Projet de rattachement",
  selectFile: "Sélectionner un fichier",
  selectAttachment: "Sélectionner une pièce jointe",
  selectedAttachmentName: "Nom de la pièce jointe sélectionnée",
  selectedFileName: "Nom du fichier sélectionné",
  startDate: "Date de début",
  templateName: "Nom du modèle",
  reportIncidentToSupport: "Signaler un problème au support",
  reportIncident: "Déclarer un incident",
  triggeredBy: "Mis dans ce statut par",
  userManuals: "Modes opératoires",
  deactivate: "Êtes-vous sûr de vouloir désactiver cet élément ?",
  activate: "Êtes-vous sûr de vouloir activer cet élément ?",
  validationDate: "Date de validation",
};

const entities = {
  agency: "Etablissement",
  agencies: "Etablissements",
  attachment: "Attachement",
  attachments: "Attachements",
  bpu: "BPU",
  bpus: "BPUs",
  bpuTemplate: "BPU Template",
  bpuTemplates: "BPU Templates",
  businessUnit: "Unité organisationnelle",
  businessUnits: "Unités organisationnelles",
  comment: "Commentaire",
  company: "Société",
  companies: "Sociétés",
  contractorAgreement: "Marché Sous-traitant",
  contractorAgreements: "Marchés Sous-traitant",
  contractTemplate: "Modèle de contrat",
  contractTemplates: "Modèles de contrat",
  documentType: "Type de document",
  documentTypes: "Types de document",
  notifications: "Notifications",
  oracleProject: "Projet Oracle",
  oracleTask: "Tache Oracle",
  oracleEmitterProject: "Projet Oracle émetteur",
  oracleEmitterTask: "Tache Oracle émetteur",
  oscarProject: "Projet OSCAR",
  oscarProjects: "Projets OSCAR",
  oscarSubProject: "Sous-projet OSCAR",
  oscarSubProjects: "Sous-projets OSCAR",
  oracleConfiguration: "Configuration Oracle",
  oracleImputations: "Mapping Imputations/Projets/Taches Oracle",
  oracleRgWarranties: "Libération RGs/Cautions",
  order: "Commande",
  orders: "Commandes",
  orderTemplate: "Modèle de commande",
  orderTemplates: "Modèles de commande",
  paymentGuarantee: "Garantie de Paiement",
  paymentGuarantees: "Garanties de Paiement",
  paymentType: "Type de paiement",
  paymentTypes: "Types de paiement",
  paymentTerm: "Condition de paiement",
  paymentTerms: "Conditions de paiement",
  prestation: "Prestation",
  prestations: "Prestations",
  prestationReference: "Référence de prestation",
  prestationReferences: "Références de prestation",
  prestationType: "Type de prestation",
  prestationTypes: "Types de prestation",
  projectType: "Type de projet",
  projectTypes: "Types de projet",
  role: "Rôle",
  roles: "Rôles",
  situation: "Situation mensuelle",
  situations: "Situations mensuelles",
  task: "Tâche",
  tasks: "Tâches",
  unit: "Unité",
  units: "Unités",
  user: "Utilisateur",
  users: "Utilisateurs",
  workflowNode: "Noeud de workflow",
  contract: "Contrat",
  popups: "Popups",
};

const login = {
  title: "Interface de Suivi Financier",
  username: "Identifiant",
  password: "Mot de passe",
  forgotPassword: "Mot de passe oublié ?",
  connexion: "Connexion",
};

const home = {
  nothingToValidate: "Aucune commande, attachement ou marché sous-traitant à valider.",
  myOrders: "Mes commandes à traiter",
  myAttachments: "Mes attachements à traiter",
  myMarkets: "Mes marchés sous-traitant à traiter",
  workflowProcess: "Workflows à traiter",
  ongoingWork: "Travaux en cours",
  ongoingOrders: "Commandes en cours de",
};

const agencies = {
  addUser: "Ajouter un utilisateur",
  agencyCreation: "Création d'un etablissement",
  anomalies:
    "L'établissement présente une anomalie administrative (soit un dossier incomplet, soit fait l'objet d'une procédure collective, soit est fermé).",
  inviteMailHint:
    "Ce mail correspond à celui de votre sous-traitant qui recevra la demande d'adhésion et les relances.",
  columns: {
    agencyCode: "Code etablissement",
    address: "Coordonnées etablissement",
    manager: "Responsable",
    edifice: "Édifice",
    inviteMail: "E-mail d'invitation",
  },
  administrativeDocuments: "Dossier administratif",
  nolegalDocuments: "Aucun document n'a été récupéré depuis e-attestation.",
};

const attachments = {
  exportBPU: "Exporter (BPU)",
  unrecordedBenefits: "Aucune prestation enregistrée",
  amountWoVat: "Montant de l'attachement HT",
  wfStatus: "Statut WF",
  cumulativePreviousAmount: "Montant des attachements précédents HT",
  cumulativeAmount: "Montant des attachements (Précédents + courant) HT",
  currentPeriodAmount: "Montant de cet attachement HT",
  completionDate: "Fin prévue le",
  totalAmount: "Montant total de la commande HT",
  observationCMD: "Observation (CMD)",
  finalBilling: "Décompte définitif",
  evaluationDate: "Évaluation",
  resendToOracle: "Envoyer dans Oracle",

  prestationColumns: {
    orderQuantity: "Quantité de la commande",
    orderAmount: "Montant de la commande",
    cumulativeQuantity: "Quantité des attachements (Précédents + courant)",
    cumulativeAmount: "Montant des attachements (Précédents + courant)",
    cumulativePreviousQuantity: "Quantité des attachements précédents",
    cumulativePreviousAmount: "Montant des attachements précédents",
    currentQuantity: "Quantité pour cet attachement",
    currentAmount: "Montant pour cet attachement",
    help: "Quantités de tous les attachements précédents ainsi que celles de l'attachement courant. Les quantités des attachements suivants ne sont pas prises en compte.",
    helpTwo:
      "Quantité de tous les attachements précédents, dont la date de mise en validation est antérieure à celle de l'attachement courant.",
  },

  attachmentCreation: "Création d'un attachement",
  validatedOrders: "Liste des commandes validées",
  sameMonthAttachment:
    "Attention vous avez déjà attaché cette commande ce mois-ci. Souhaitez-vous continuer ?",
  prestationSelection: "Selection des prestations",
};

const bpus = {
  bpuCreation: "Création d'un BPU",
};

const bpuTemplates = {
  bpuTemplateCreation: "Création d'un BPU Template",
};

const categories = {
  parentCategory: "Catégorie parente",
  mergeDuplicates: "Fusionner les doublons",
  categoryCreation: "Création d'une catégorie",
};

const companies = {
  agencyCreation: "Création d'un etablissement",

  companyCreation: "Création d'une société",
  columns: {
    edificeCode: "Code édifice",
  },
};

const contractTemplates = {
  addContractTemplate: "Ajout d'un modèle de contrat",
  downloadContractTemplate: "Télécharger un modèle de contrat",
  contractTemplateName: "Nom du modèle de contrat",
};

const dc4 = {
  title: "Suivi des DC4",
  attachmentsPaid: "Montant Attachements Payés",
  readyToPayAttachments: "Montant Attachements Situation Mensuelle",
  validatedAttachments: "Montant Attachements Validés",
  allAttachments: "Montant HT Attachements validés/situation mensuelle/payés",
  availableDC4: "Disponible sur DC4",
  availableDC4WithRad: "Disponible sur DC4 avec RAD",
};

const deposits = {
  depositAmount: "Montant de la caution",
  depositUsed: "Montant utilisé",
  amountLeft: "Montant restant",
  reimbursementDate: "Date de mainlevée",
  addDeposit: "Ajout d'une caution",
};

const envelopes = {
  addEnvelope: "Ajouter une enveloppe",

  validation: {
    sendToValidation: "Envoyer en validation",
    atLeast2RolesRequired:
      "Un minimum de deux profils validateurs sont nécessaires, veuillez contacter un administrateur",
    eachRoleMustSelectAUser:
      "Veuillez associer un utilisateurs pour chaque rôles",
    validatorSelectionModalTitle: "Selection des validateurs",
  },

  signature: {
    sendForSignature: "Envoyer en signature",
    signersModalTitle: "Coordonnées des signataires",
    axioneSide: "Axione",
    contractorSide: "Sous-traitant",
    signaturePosition: "Positionnement de la signature",
    anchorString: "Clé de positionnement",
    positionHelper:
      "En mode manuel les signataires positionnent eux-mêmes leur signature dans le document.\nEn mode automatique, la signature est positionnée grâce à une clé (chaîne de caractères).\nLes clés de positionnement doivent être de la même couleur que le fond du document afin qu'elles ne soient pas visibles dans le document final.",
    anchorStingsShouldBeDifferent:
      "Les clés de positionnement doivent être différentes",
    successfullySent: "Contrat envoyé en signature avec succès",
    failedSent: "Une erreur s'est produite lors de l'envoi en signature",
    manual: "Manuel",
    automatic: "Automatique",
    sendError: "Erreur d'envoi à la signature",
  },
  none: "Aucune enveloppe",
};

const documentTypes = {
  documentTypeCreation: "Création d'un type de document",
};

const markets = {
  nbAttachments: "NB Attachements",
  currentBpu: "BPU en cours",
  marketCreation: "Création d'un marché",
  deactivate: "Désactiver",
  activate: "Activer",

  columns: {
    agencyCode: "Code etablissement (Nom du marché)",
    edifice: "Référence interne contrat",
    contractNumber: "Numéro de contrat",
    dateEndOfContract: "Date de fin de validité du contrat",
    eotpSt: "eOTP ST",
    marketNumber: "N° Marché SAP",
    clientBdc: "BDC client",
    maxAmountDC4: "Montant Max DC4 HT",
    paymentCondition: "Condition de paiement",
    paymentType: "Type de paiement",
    thresholdAmount: "Montant seuil",
    rgRate: "Taux RG",
    vatType: "Type de TVA",
    activated: "Actif",
  },
  vatTypes: {
    basic: "20%",
    tenPercents: "10%",
    reverseCharge: "Autoliquidée",
  },
};

const notifications = {
  refus: "Vous devez justifier le refus.",
  min: "(5 caractères minimum).",
  title: "Titre",
  active: "Actif",
};

const ods = {
  title: "Masque d'OD",
  situationDate: "Date situation mensuelle",
  attSubcontractor: "ATT sous-traitant",
  senderEotp: "Elément eOTP émetteur",
  receiverEotp: "Elément eOTP destinataire",
  amount: "Montant € HT",
  accountingNature: "Nature Comptable",
};

const oscarSubProjects = {
  constructionBaseQuantities: "Quantités base construction",

  columns: {
    subProjectYear: "Année du sous-projet",
    subProjectCity: "Commune du sous-projet",
    subprojectStatus: "Etat du sous-projet",
    arcgisName: "Nom Arcgis",
    oscarSubProject: "Sous-projet OSCAR",
    arcgisReference: "Référence Arcgis",
    oiCode: "Code OI",
    marketType: "Type de marché",
    projectName: "Nom du projet",
    subProjectName: "Nom du sous-projet",
    nroName: "Nom du NRO",
    nroIpeId: "Id IPE NRO",
    pmIpeId: "Id IPE PM",
    pmOfferId: "ID OFFRE PM",
    pmAxioneId: "ID interne Axione du PM",
    pmCity: "Commune du PM",
  },
};

const orders = {
  releaseSituation: "Situation de libération",
  wfStatus: "Statut WF",
  displayAllPrestations: "Afficher toutes les prestations du BPU Sous-traitant",
  total: "Total de la commande HT",
  totalTTC: "Total de la commande TTC",
  totalPrestation: "Total de la prestation",
  totalPrestationTTC: "Total de la prestation TTC",
  invoiced: "Déjà facturé",
  releaseDate: "Date de libération de la RG",
  needMarket: "Nécessite un marché",
  needOracleProject: "Nécessite un projet Oracle",
  orderCreation: "Création d'une commande",
  resendToOracle: "Envoyer la commande dans Oracle",
  fillOracleEmitterProjectAndTask: "Renseigner le projet et la tâche Oracle émetteur",

  columns: {
    edifice: "Référence interne contrat",
    contractNumber: "Numéro de contrat",
    complement: "Compléments / Détails",
    clientMarket: "Marché client",
    completionDate: "Fin prévue le",
    deliveryDuration: "Délai de réalisation",
    bdcCustomer: "BDC client",
    managedBy: "Suivi par",
    mainClient: "Client principal",
    orderManagedBy: "Affaire suivie par",
    sstMarket: "Marché SST",
    deliveryDate: "PV de réception",
  },
};

const orderTemplates = {
  switchAll: "Tout ouvrir/fermer",
  templateCreation: "Création d'un modèle de commande",
};

const paymentGuarantees = {
  fieldNamesMustBeInList:
    "Les noms des champs du formulaire doivent faire partie des noms suivants :",
  addGuarantee: "Ajout d'une garantie de paiement",
};

const prestations = {
  needCategory: "Nécessite une catégorie",
  prestationCreation: "Création d'une prestation",

  columns: {
    unitPrice: "Prix unitaire",
    itemCode: "Code article",
  },
};

const prestationTypes = {
  prestationTypeCreation: "Création d'un type de prestation",
};

const projects = {
  nbOrdersValidated: "Nb CMD Validées et/ou Clôturées",
  nbAttachmentsPaid: "Nb attachements validés",
  sumOrdersValidated: "Somme CMD Validées et/ou Clôturées",
  sumAttachmentsPaid: "Somme attachements validés",
  imputationCreation: "Création d'une imputation",
  editImputation: "Modifier une imputation",
  addUserToProject: "Ajouter un utilisateur à un projet",
  monthlyGenerationDay: "Jour de génération des situations mensuelles",
  shareFiles: "Partager les attachements dans Sharepoint",

  projectCreation: "Création d'un projet",
  directorAddress: "Adresse du responsable",
  columns: {
    manager: "Responsable",
    requisitioningBU: "Unité organisationnelle",
  },
  oracleProjectCreation: "Associer un projet Oracle",
  syncProjectsWithOracle: "Synchroniser les projets Oracle"
};

const projectTypes = {
  projectTypeCreation: "Création d'un type de projet",
};

const quantitatives = {
  quantityOrdered: "Quantités commandées",
  cumulatedQuantity: "Quantités réalisés en cumulé",
  orderedAmount: "Montant commandé",
  cumulativeAmount: "Montant réalisé en cumulé",
};

const roles = {
  roleCreation: "Création d'un rôle",
  additionalPermissions:
    "Vous pouvez définir un ensemble de permissions supplémentaires sur ce rôle.",
  parentRole: "Rôle parent",
  visibilities: {
    all: "Accès à tous les éléments de la base",
    projects: "Accès limités aux projets associés à l'utilisateur",
    managerProjects:
      "Accès limités aux projets associés au responsable de l'utilisateur",
    projectsOffices:
      "Accès limités aux projets ET aux etablissements associés à l'utilisateur",
  },
};

const situations = {
  download_csv_by_bdc: "Télécharger en CSV par BDC",
  markPaid: "Envoyer dans Oracle",
  cancelPayment: "Revenir en situation (ne renverra pas dans Oracle)",
  attachmentNo: "N° attachement",
  releasedAmount: "Montant RG libérée HT",
  sapReference: "Référence dans SAP",
  theoreticalPaymentDate: "Date de paiement théorique",
  currentMonthAmount: "Montant HT du mois",
  rgAmount: "Montant HT RG",
  bondAmount: "Montant cautionné",
  withheldAmount: "Montant non cautionné",
  amountWoRg: "Montant HT-RG",
  totalAmountWoVat: "Montant total HT",
  vatAmount: "Montant TVA",
  reverseChargeAmount: "Montant TVA Autoliquidée",
  totalAmount: "Montant à payer TTC",
  releaseSituation: "Situation de libération",
  releaseDate: "Date de libération de la RG",
  totalWoVat: "Total HT",
  totalWithVat: "Total TTC",
  situationCreation: "Création d'une situation mensuelle",
  projectSelection: "Selection des projets",
};

const units = {
  unitCreation: "Création d'une unité",
};

const users = {
  changePerimeter: "Changer le périmètre",
  projectType: "Type de projet",
  secondaryProfiles: "Profils secondaires",
  assignPerimeterToUser: "Affecter le périmètre à un autre utilisateur",
  authorizationAmount: "Montant d'engagement",
  mainProfile: "Profil principal",
  addUser: "Ajout d'un utilisateur",
  ldapCommonName: "LDAP CommonName",
  columns: {
    manager: "Responsable",
  },
};

const warranties = {
  title: "Suivi des RG/Cautions",
  depositType: "RG/Caution",
  attachementAmount: "Montant ATT validés",
  totalRetention: "Montant total RG à retenir",
  releasedAmount: "Montant RG libérée",
  remainingAmount: "Montant restant",
  bondAmount: "Montant cautionné",
  withheldAmount: "Montant des retenues non cautionnées",

  orderReference: "Référence commande",
  orderEndDate: "Date de fin de commande",
  deliveryDate: "Date PV de réception",
  releaseDate: "Date libération RG",
  attAmount: "Montant des ATT",
  attAmountHelp: "ATT validés + ATT Situation mensuelle + ATT validés",
  rgHelp: "Retenue de garantie",
  bondRg: "RG cautionnée",
  bondRgHelp: "Montant utilisé sur une caution",
  withheldRg: "RG non cautionnée",
  rgReleased: "RG libérée",
  rgReleasedHelp: "RG déjà libérée dans une situation mensuelle",
  rgToRelease: "RG à libérer",
  rgToReleaseHelp: "RG restant à libérer sur une situation mensuelle",
  rgFromDepositReleased: "RG libérée via une caution",
  rgFromDepositReleasedHelp: "RG libérée par l'ajout d'une caution",
  retentionTypes: {
    basic: "Retenue de garantie",
    withThreshold: "Retenue de garantie avec seuil",
    nonApplicable: "Non concerné",
  },
  hideEmptyRG: "Cacher les lignes vide",
  hideOracle: "Cacher les RG deja dans Oracle",
};

const errors = {
  many2OneField: {
    selectItem: "Le champ {field} est obligatoire",
  },
};

const account = {
  myAccount: "Mon compte",
  delegation: {
    delegations: "Mes délégations",
    noDelegation: "Vous n'avez pas paramètré de délégations de droits.",
    delegationCreation: "Création d'une délégation",
    delegateTo: "Délégué à",
    receivedDelegations: "Délégations reçues",
    noReceivedDelegation: "Vous n'avez reçu aucune délégations de droits.",
    delegateFrom: "Délégation de",
    userToDelegate: "Utilisateur a déléguer",
    userDelegated: "Utilisateur recevant la délégation",
    userDelegations: "Délégation de l'utilisateur",
    userNoDelegation:
      "L'utilisateur n'a pas paramètré de délégations de droits.",
    userNoReceivedDelegation:
      "L'utilisateur n'a reçu aucune délégations de droits.",
    byDelegationOf: "en délégation de",
  },
};

const contract = {
  contractNumber: "Numéro de contrat",
  parentContract: "Contrat parent",
  contractType: "Type de contrat",
  signatureDate: "Date de signature",
  startDate: "Entrée en vigueur",
  endDate: "Date d'expiration",
  duration: "Délai de préavis",
  terminationDate: "Date de résiliation",
  expirationDateAfterRenewal: "Date d'expiration après reconductions",
  referent: "Acheteur référent",
  referentOracle: "Acheteur référent Oracle",
  adminReferent: "Contrat admin référent",
  active: "Actif",
  contractCreation: "Création d'un contrat",
  contractChild: "Contrats enfants",
  noChildContracts: "Aucun contrat enfants.",
};

const popup = {
  tabs: {
    content: "Contenu de la popup",
    users: "Utilisateurs",
    information: "Informations",
  },
  addUsers: "Ajouter des utilisateurs",
  removeUsers: "Supprimer des utilisateurs",
  readedAt: "Lu",
  closedAt: "Fermé",
};

const evaluation = {
  companies: "Sociétés",
  agencies: "Établissements",
  contracts: "Contrats",
  projects: "Projets",
  subcontractorsMarkets: "Marchés sous-traitant",
  evaluation: "Évaluation",
  enableAllEvaluation: "Activer toutes les évaluations",
  disableAllEvaluation: "Désactiver toutes les évaluations",
  rating: "Note",
  comment: "Commentaire",
  safetyTitle: "Évaluation sécurité",
  procurementTitle: "Évaluation achat",
  projectTitle: "Évaluation du projet",
  procurement: "Achat",
  project: "Project",
  type: "Type",
  document: "Document",
  search: "Rechercher",
  averageRatings: "Notes moyennes",
  averageRating: "Note moyenne",
  ratingDate: "Dates des évaluations",
  agencyNumber: "Nombre d'établissements",
  ratingNumber: "Nombre d'évaluations",
  ratingNumbers: "Nombre évaluations",
  gaugeRadar: "Radar des notes",
  companyList: "Liste des sociétés",
  submit: "Soumettre",
  feedbackWarning:
    "Veuillez fournir un commentaire pour une note inférieure à 3.",
  deleteEvaluation: "Confirmer la suppression de l'évaluation?",
  helper: {
    intro:
      "Évaluez chaque critère sur une échelle de 1 à 5 étoiles. Un commentaire est requis pour les notes inférieures à 3 étoiles.",
    commentRequired: "Veuillez expliquer votre évaluation (obligatoire)",
    commentOptional: "Commentaire (optionnel)",
    errorMessage:
      "Veuillez fournir un commentaire pour une note de 2 étoiles ou moins.",
    skipLabel:
      "Cocher cette case si vous avez déjà évalué, ou, ne pouvez pas évaluer cet attachement",
  },

  buttons: {
    submit: "Soumettre",
    cancel: "Annuler",
    skip: "Passer",
  },
  quality: {
    label: "Note qualité",
    specs: "Respect des spécifications",
    materials: "Qualité des prestations / matériaux",
    controls: "Auto-contrôles / Maîtrise des essais",
    compliance: "Conformité du DOE / récolement",
    installation:
      "Facilité de pose ou d'utilisation par le chantier (fournisseurs)",
    packaging: "Emballage / Conditionnement (fournisseurs)",
    execution:
      "Conformité dans l'exécution de la prestation ou de la fourniture",
    incidents:
      "Transparence dans la remontée des dysfonctionnements (incidents/accidents)",
    value: "Respect qualité/ prix",
  },
  technical: {
    label: "Note technique",
    studies: "Etudes techniques",
    plans: "Fiabilité des plans d'exécution",
    aptitude: "Aptitude technique à répondre au besoin",
    proposition:
      "Force de proposition - variantes / autonomie (existence d'un BE)",
    innovation: "Innovation",
    qualification:
      "Qualification du personnel technique / Conseils donnés / Encadrement",
    assistance: "Disponibilité de l'assistance technique",
    organization: "Organisation du chantier",
    responses: "Qualité des réponses à l'appel d'offre",
  },
  deadlines: {
    label: "Note délais",
    offers: "Respect des délais",
    intervention: "Moyens mis en oeuvre",
    reactivity: "Réactivité",
    availability: "Logistique",
    contractual: "Respect des délais contractuels",
    commitments: "Respects des engagements",
  },
  safety: {
    label: "Sécurité",
    rules: "Indicateurs Sécurités issus des visites ",
    regulations:
      "Evaluation tous les semestres  par les préventeurs en fonction des audits qui ont été réalisés sur des sites avec les opérationnels",
  },
  relational: {
    label: "Note Relationnel",
    quality: "Qualité de la relation",
    communication: "Qualité de la communication",
    responses: "Qualité des réponses aux consultations",
    procedure: "Respect de la procédure administrative (ex : attestations)",
    billing: "Conformité de la facturation / situation",
    disputes: "Litiges",
    attendance: "Assiduité aux réunions",
    commercial: "Efficacité commerciale",
    payment: "Paiement PQFA",
  },
  rse: {
    label: "Note RSE",
    environment: "Respect des exigences en matière d'environnement",
    waste:
      "Gestion des déchets et évacuation dans les bonnes filières de traitement",
    impact: "Impact environnemental du produit (fournisseurs)",
    packaging:
      "Conditionnement / Emballage / stockage des produits dangereux (fournisseurs)",
    transparency:
      "Transparence dans la remontée des dysfonctionnements (incidents/accidents)",
    ethics: "Respect du code d'éthique AXIONE",
    standards: "Respect des normes du travail",
    performance: "Performance RSE",
    insertion: "Insertion",
  },
};

const oracleStatus = {
  NOT_CONCERNED: "Non concerné",
  NOT_AVAILABLE: "Non disponible",
  PROCESSING: "En cours",
  SUCCESS: "Succès",
  ERROR: "Erreur",
  FAILURE: "Echec",
};

const oracle = {
  bindOrders: "Associer les commandes",
  bindOrdersHelp: "Associer les commandes avec les projets et taches Oracle ?",
  rgWarranties: {
    errorModal: "Report d'une erreur",
    reportError: "Reporter une erreur",
    successModal: "Libération RGs/Cautions",
    invoiceName: "Nom de la facture",
    report: "Reporter",
    status: "Status",
    statusReason: "Commentaire",
    sendBackToProcessing: 'Retour a "en cours"',
    confirmBackToProcessing:
      'Êtes-vous sûr de vouloir renvoyer cette RG/Caution dans le status "En cours" ?',
    confirm: "Confirmer",
  },
  removeFromListHelp:
    "Confirmer la suppression des imputations sélectionnées ?",
  noSelection: "Aucune imputation sélectionnée",
  synchronizeProjects: "Synchroniser les projets",
  synchronizeImputations:
    "Synchroniser les imputations avec les projets et taches Oracle ?",
  sendOrders: "Envoyer les commandes",
  sendOrdersHelp: "Envoyer les commandes vers Oracle ?",
  renameUsers: "Renommer les utilisateurs (Oracle)",
  renameUsersConfirmation:
    "Confirmer le renommage des utilisateurs au format Oracle ?",
  usersRenamed: "Les utilisateurs ont été renommés avec succès",
};

export default {
  agencies,
  attachments,
  bpus,
  bpuTemplates,
  categories,
  common,
  companies,
  contractTemplates,
  dc4,
  deposits,
  documentTypes,
  entities,
  expressions,
  home,
  login,
  markets,
  notifications,
  ods,
  orders,
  orderTemplates,
  oscarSubProjects,
  paymentGuarantees,
  prestations,
  prestationTypes,
  projects,
  projectTypes,
  quantitatives,
  roles,
  situations,
  units,
  users,
  warranties,
  errors,
  account,
  contract,
  popup,
  evaluation,
  envelopes,
  oracleStatus,
  oracle,
};
